import { ElementRef } from "@angular/core";

export class ElementConfig {
    container : HTMLElement;
    private commentsBtn = "[rlAnnotatorCommentBtn]";
    private commentsPanel = "rl-annotator-comments-panel";
    private file = "[rlAnnotatorFile]";
    private img = ".textLayer";
    private page = "[data-page-number='#PAGE#'] .textLayer";
    private fileContant = ".ng2-pdf-viewer-container";
    private scroll = {
        element : ".page",
        container : this.fileContant + ",body"
    }

    constructor(container : ElementRef){
        this.container = container.nativeElement;
    }

    find = (element : 'commentsPanel' | 'commentsBtn' | 'file' | 'img' | 'fileContant' | string) => {
        let e = this.container.querySelector(this[element] ? this[element] : element);
        if(e && e.querySelector('iframe')){
            let iframe = e.querySelector('iframe');
            return iframe.contentDocument || iframe.contentWindow.document;
        }
        
        return e;
    }

    findPage = (pageNum : number) => this.find(this.page.replace("#PAGE#", pageNum + ""));

    findAll = (element : 'img') => this.container.querySelectorAll(this[element]);

    scrollToAnnotation(annElement, ann){
        var scrollTo = window['$'](this.scroll.element)[ann.page - 1].offsetTop + ann.offsetTop; //+ window['$'](annElement)[0].offsetTop;
        window['$'](this.scroll.container).animate({scrollTop: scrollTo }, 1000);
    }

    getPage(element){

    }
}